import React, { Component } from 'react';

import Regua from '../../components/Regua/Regua';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import LegacyMode from '../../components/LegacyMode/LegacyMode';
import TesterMode from '../../components/TesterMode/TesterMode';

class LayoutPublic extends Component {
  render() {
    return (
      <>
        <SEO title={this.props.title ?? ''} />
        <LegacyMode />
        <TesterMode />
        <div>
          {this.props.children}
        </div>
        <Regua open={false} />
        <Footer open={false} />
      </>
    );
  }
}

export default LayoutPublic;